import { useAsync, useMountEffect } from "@react-hookz/web";
import axios from "axios";

import { config } from "shared/data";

export const useNavigatorInfo = () => {
  const [asyncState, { execute }] = useAsync(async () => {
    const response = await axios.get<Response>(config.navigatorInfo.url, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        apiKey: config.navigatorInfo.apiKey,
      },
    });

    const parsed: NavigatorInfo = {
      botScore: response.data["Bot-Score"] ?? 0,
      botScoreGroup: getBotScoreGroup(response.data["Bot-Score"]),
      country: response.data["CF-IPCountry"],
      ip: response.data.IP,
      isBot: response.data["IsVerifiedBot"] === true,
    };

    return parsed;
  });
  useMountEffect(execute);

  type Response = {
    "Bot-Score": number;
    "CF-IPCountry": string;
    IP: string;
    IsVerifiedBot: boolean;
  };

  return asyncState;
};

const getBotScoreGroup = (botScore: null | number) => {
  if (!botScore) return "0";

  switch (true) {
    case botScore === 0:
      return "0";
    case botScore < 30:
      return "1-29";
    case botScore < 36:
      return "30-35";
    case botScore < 41:
      return "36-40";
    case botScore < 46:
      return "41-45";
    case botScore < 100:
      return "46-99";
    default:
      return "0";
  }
};

export type NavigatorInfo = {
  botScore: number;
  botScoreGroup: "0" | "1-29" | "30-35" | "36-40" | "41-45" | "46-99";
  country: string;
  ip: string;
  isBot: boolean;
};
